export const SET_THEMES = 'templates/themes/SET_THEMES';
export const SET_THEMES_PACKAGES = 'templates/themes/SET_THEMES_PACKAGES';
export const UPDATE_PACKAGES_FOR_THEME = 'templates/themes/UPDATE_PACKAGES_FOR_THEME';
export const SET_FETCHING = 'templates/themes/SET_FETCHING';